import i18next from 'i18next';

export const criarCurriculo = function () {
    "use strict";

    var $divModal = '#modal-primeiroCad';
    var $modal = body.find($divModal);

    var _salvar = function (tipo) {
        window.global.loaderPanel.show($divModal);

        var inputHotSite = body.find('#hotSiteEmpresaID');
        var hotSiteEmpresaID = inputHotSite.length > 0 ? inputHotSite.val() : '';


        $.ajax({
            type: "POST",
            url: '/' + CULTURE_EMPREGARE + '/PainelCurriculoAntigo/Create', cache: false,
            data: { tipo: tipo, hotSiteEmpresaID: hotSiteEmpresaID },
            success: function (data) {
                if (data.success == 1) {
                    window.location.reload();
                }
                else {
                    swal("", data.error, "error");
                    window.global.loaderPanel.hide($divModal);
                }

            },
            error: function () {
                window.global.loaderPanel.hide($divModal);
                swal("", i18next.t('erroServidor'), "error");
            }
        });
    };

    var _abrir = function () {
        $modal.modal();
    };

    var init = function () {
        _abrir();
        window.global.origemCadastro.salvar(true);
        $modal.find('.list-group-item').on('click', function (e) {
            var tipo = $(this).attr('data-tipo');
            _salvar(tipo);
            e.preventDefault();
        });
    }

    return init();
};



